export const extractQueryParameters = (url) => {
    var parameters = {};
    if (url.includes('?')) {
        var queryString = url.split('?')[1];
        var queryParameters = queryString.split('&');
        for (var i = 0; i < queryParameters.length; i++) {
            var keyValuePair = queryParameters[i].split('=');
            if (keyValuePair.length === 2) {
                var key = keyValuePair[0];
                var value = keyValuePair[1];
                parameters[key] = value;
            }
        }
    }
    return parameters;
}